import { loginParam, LoginUserInfo } from '@/types/upms/login';
import { UserInfo } from '@/types/upms/user';
import { BaseController } from '@/api/BaseController';
import { RequestOption, TableData } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { API_CONTEXT } from '../config';

export default class LoginController extends BaseController {
  static login(params: loginParam) {
    return super.post<UserInfo>(API_CONTEXT + '/upms/login/doLogin', params);
  }

  static logout() {
    return super.post(API_CONTEXT + '/upms/login/doLogout', {});
  }

  static changePassword(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/login/changePassword', params, httpOptions);
  }

  static changeHeadImageUrl() {
    return API_CONTEXT + '/upms/login/changeHeadImage';
  }
  //发送短信验证码
  static sendSmsCode(params: ANY_OBJECT) {
    return super.post(API_CONTEXT + '/upms/login/sendSmsCode', params);
  }

  //手机号注册
  static mobileRegister(params: ANY_OBJECT) {
    return super.post(API_CONTEXT + '/upms/login/mobileRegister', params);
  }

  //手机号验证码登录
  static mobileLogin(params: ANY_OBJECT) {
    return super.post(API_CONTEXT + '/upms/login/mobileLogin', params);
  }
}
